import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#6C7072",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.6",
      d: "M23.833 16.25v-6.5c0-5.417-2.167-7.583-7.584-7.583h-6.5c-5.416 0-7.583 2.166-7.583 7.583v6.5c0 5.417 2.167 7.583 7.583 7.583h6.5c5.417 0 7.584-2.166 7.584-7.583M2.73 7.703h20.54M9.23 2.286v5.265M16.77 2.286v4.778"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#6C7072",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.6",
      d: "M10.563 15.654v-1.3c0-1.668 1.18-2.35 2.621-1.516l1.127.65 1.127.65c1.44.834 1.44 2.199 0 3.033l-1.127.65-1.127.65c-1.44.834-2.621.152-2.621-1.517z"
    }, null, -1)
  ]))]))
}
export default { render: render }